// Default country code used when a stored number has none of its own.
// Leads are entered locally, so a bare 10-digit number is an Indian mobile.
const DEFAULT_COUNTRY_CODE = "91";

// Reduces however the number happens to be stored - "9825829169",
// "+91 7600 500 188", "091-98258 29169" - down to the plain international
// digits WhatsApp expects (no "+", no spaces). Returns null when the value
// can't be a real number.
export const normalizeWhatsAppNumber = (phoneNumber) => {
  let digits = String(phoneNumber || "").replace(/\D/g, "");
  if (!digits) return null;

  // Trunk prefix ("0" before a local number) is not part of the dialable
  // international number.
  digits = digits.replace(/^0+/, "");

  // A bare local mobile number needs the country code prepended; anything
  // longer already carries one (e.g. 91XXXXXXXXXX).
  if (digits.length === 10) {
    digits = `${DEFAULT_COUNTRY_CODE}${digits}`;
  }

  // Too short to be a real number even after normalising.
  if (digits.length < 11) return null;

  return digits;
};

const isMobileDevice = () => {
  if (typeof navigator === "undefined") return false;
  if (typeof navigator.userAgentData?.mobile === "boolean") {
    return navigator.userAgentData.mobile;
  }
  return /Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry/i.test(
    navigator.userAgent || ""
  );
};

// Desktop goes straight to WhatsApp Web, because wa.me/api.whatsapp.com first
// show an "Open app / Continue to WhatsApp Web" chooser page there. On phones
// and tablets wa.me is still the right link - it hands off to the installed
// app directly, which web.whatsapp.com cannot do.
export const buildWhatsAppUrl = (phoneNumber) => {
  const digits = normalizeWhatsAppNumber(phoneNumber);
  if (!digits) return null;

  return isMobileDevice()
    ? `https://wa.me/${digits}`
    : `https://web.whatsapp.com/send?phone=${digits}`;
};

// Opens the chat in the WhatsApp app on mobile, or WhatsApp Web on desktop.
export const openWhatsApp = (phoneNumber) => {
  const url = buildWhatsAppUrl(phoneNumber);
  if (!url) return false;
  window.open(url, "_blank", "noopener,noreferrer");
  return true;
};
